import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import { STATIC_ATTRIBUTES } from '@client/components/blocks/Text/plugins/constants'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'

const UNSUBSCRIBE_MARKUP = `##${STATIC_ATTRIBUTES[1].code}##`

export const RequiredLinksFooter = ({
  editor = EditorModelNULL,
  app = AppModelNULL,
  serverRender = false,
}) => {
  const { missingAttrs } = editor
  const unsubscribeIsMissing = missingAttrs.includes(UNSUBSCRIBE_MARKUP)

  return (
    <If condition={unsubscribeIsMissing}>
      <div>
        <table
          className={serverRender ? '' : 'section'}
          role="presentation"
          cellSpacing="0"
          cellPadding="0"
          border="0"
          align="center"
          width="100%"
          style={{
            borderSpacing: '0',
            color: '#666666',
            fontFamily: 'sans-serif',
          }}
        >
          <tbody>
            <tr>
              <td align="center">
                <p
                  style={{
                    color: '#666666',
                    fontSize: '12px',
                    margin: '10px 20px',
                  }}
                >
                  {app.formatMessage('requiredLinksFooter.message')}
                </p>
                <p
                  style={{
                    color: '#666666',
                    fontSize: '12px',
                    margin: '10px 20px',
                  }}
                >
                  <a
                    style={{ color: '#666666', textDecoration: 'underline' }}
                    target="_blank"
                    href="##update_contact##"
                  >
                    {app.formatMessage('requiredLinksFooter.updateContactLink')}
                  </a>
                  <span>&nbsp;|&nbsp;</span>
                  <a
                    style={{ color: '#666666', textDecoration: 'underline' }}
                    target="_blank"
                    href="##unsubscribe##"
                  >
                    {app.formatMessage('requiredLinksFooter.unsubscribeLink')}
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </If>
  )
}

RequiredLinksFooter.propTypes = {
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
  serverRender: PropTypes.bool,
}

export default inject(
  'editor',
  'app',
  'serverRender'
)(observer(RequiredLinksFooter))
